export * from '@fhs/routing/src/routes/(auth)/confirm-otp';
export { default } from '@fhs/routing/src/routes/(auth)/confirm-otp';
